<template>
    <div class="row dt-extra ajax-filters">
        <v-search-filter
                v-if="textCols.length"
                :columns="textCols"
                ref="filter_1"
        ></v-search-filter>
        <v-date-filter
                v-if="dateCols.length"
                :columns="dateCols"
                ref="filter_2"
        ></v-date-filter>
        <v-numeric-filter
                v-if="numericCols.length"
                :columns="numericCols"
                ref="filter_3"
        ></v-numeric-filter>

        <div class="col-sm-12 text-right">

                <button type="button" class="btn red btn-sm" @click.prevent="resetFilters">
                    <i :class="loading ? 'fa fa-spinner fa-spin' : 'fa fa-close'"></i>
                    {{ $t('messages.BTN_RESET_FILTERS') }}
                </button>
                <button type="button" class="btn blue btn-sm" @click.prevent="applyFilters">
                    <i :class="loading ? 'fa fa-spinner fa-spin' : 'fa fa-search'"></i>
                    {{ $t('messages.BTN_APPLY_FILTERS') }}
                </button>

            <hr>
        </div>
    </div>
</template>

<script>
  import VSearchFilter from './SearchFilter'
  import VDateFilter from './DateFilter'
  import VNumericFilter from './NumericFilter'

  /**
   * Events:
   * @onSearch(queryParams)
   */
  export default {
    components: {
      VSearchFilter,
      VDateFilter,
      VNumericFilter
    },
    props: {
      /**
       * An array of objects having following structure:
       * {title: colTitle, idx: columnIndex}
       */
      textCols: {
        type: Array,
        default () {
          return []
        }
      },
      dateCols: {
        type: Array,
        default () {
          return []
        }
      },
      numericCols: {
        type: Array,
        default () {
          return []
        }
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    methods: {
      applyFilters () {
        let queryParams = {}
        for (let ref in this.$refs) {
          if (this.$refs.hasOwnProperty(ref) && /^filter_/.test(ref)) {
            queryParams = Object.assign(queryParams, this.$refs[ref].getQuery())
          }
        }

        this.$emit('onSearch', queryParams)
      },
      resetFilters () {
        for (let ref in this.$refs) {
          if (this.$refs.hasOwnProperty(ref) && /^filter_/.test(ref)) {
            this.$refs[ref].reset()
          }
        }

        this.$emit('onSearch', {})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/datatables/AjaxFilters.vue